import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/jotai@2.15.2_@types+react@19.2.7_react@19.2.3/node_modules/jotai/esm/react.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.5_next@15.5.9_react-dom@19.2.3_react@19.2.3__react@19.2.3_sass@1.95.0__react@19.2.3/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.9_react-dom@19.2.3_react@19.2.3__react@19.2.3_sass@1.95.0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Funnel_Display\",\"arguments\":[{\"weight\":[\"300\",\"400\",\"500\",\"700\"],\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"funnelDisplayFont\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.9_react-dom@19.2.3_react@19.2.3__react@19.2.3_sass@1.95.0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Jost\",\"arguments\":[{\"weight\":[\"300\",\"400\",\"500\",\"700\"],\"style\":[\"normal\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"jostFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ClientParietteProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.sass");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/providers/DevModeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/GoogleTranslateFix.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/app/src/components/ui/tooltip.tsx");
